import { render, staticRenderFns } from "./edutalk-pancake.vue?vue&type=template&id=84ba7dbc&scoped=true"
import script from "./edutalk-pancake.vue?vue&type=script&lang=js"
export * from "./edutalk-pancake.vue?vue&type=script&lang=js"
import style0 from "./edutalk-pancake.vue?vue&type=style&index=0&id=84ba7dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ba7dbc",
  null
  
)

export default component.exports